import useListFetch, { UseListFetchProps } from '../../common/useListFetch';
import CmonUsersService from '../../services/cmon/CmonUsersService';
import CcGroup from '../../services/models/CcGroup';
import { AppConfig } from '../../AppConfig';
import { useCallback, useEffect, useReducer, useState } from 'react';
import {
    initialListState,
    listReducer,
    setListAll,
} from '../../common/listReducer';
import { getSortAlphabeticFn } from '../../common/sorting';
import { arrayFilter, arrayPages } from '../../common/filtering';
import { FetchRefreshFunctionParams } from '../../common/useFetch';
export type UseGroupListProps = Omit<UseListFetchProps, 'fetchFn'> & {
    pageSize?: number;
    useCache?: boolean;
};

// @todo refactor this to useListFetch file
type ListParams = {
    page?: number;
    pageSize?: number;
    order?: (a: any, b: any) => any;
    filters?: Function[];
};

// @todo refactor this to useListFetch file
type FilterFunctionParams = ListParams & { arr?: any[] };
type RefreshFunctionParams = FetchRefreshFunctionParams;

export default function useGroupList({
    pageSize = AppConfig.defaultPaginationConfig.pageSize,
    useCache,
}: UseGroupListProps) {
    const {
        list: groupList,
        loading,
        loaded,
        refresh: groupRefresh,
        cancel,
    } = useListFetch({
        name: 'group-list',
        useCache,
        fetchFn: async ({ ...rest }, opts) => {
            const { groups, total } = await CmonUsersService.getGroups(
                {
                    ...rest,
                },
                opts
            );
            return {
                list: groups,
                total,
            };
        },
        cancelFn: async ({ requestId }) => {
            await CmonUsersService.cancelRequest(requestId);
        },
    });
    const [list, setList] = useState<CcGroup[]>();
    const [total, setTotal] = useState<number>(0);

    const [
        {
            page: listPage,
            pageSize: listPageSize,
            order: listOrder,
            filters: listFilters,
        },
        listDispatch,
    ] = useReducer(listReducer, {
        ...initialListState,
        pageSize: pageSize || 0,
        order: getSortAlphabeticFn('ascend', (x) => x.groupName),
    });
    const filter = useCallback<(p?: FilterFunctionParams) => void>(
        ({
            page = listPage,
            pageSize = listPageSize,
            order = listOrder,
            filters = listFilters,
            arr = groupList || [],
        } = {}) => {
            listDispatch(setListAll({ page, pageSize, order, filters }));
            const filteredArr = arrayFilter({
                filters: [...(filters || [])],
                arr,
            });

            setList([
                ...arrayPages({
                    page,
                    pageSize,
                    order: order,
                    arr: filteredArr,
                }),
            ]);
            setTotal(filteredArr.length);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [listPage, listPageSize, listOrder, listFilters, groupList]
    );
    const refresh = useCallback<(p?: RefreshFunctionParams) => Promise<void>>(
        async ({
            page = listPage,
            pageSize = listPageSize,
            order = listOrder,
            filters = listFilters,
            ...rest
        } = {}) => {
            listDispatch(setListAll({ page, pageSize, order, filters }));
            await groupRefresh({
                ...rest,
            });
        },
        [listPage, listPageSize, listOrder, listFilters]
    );

    useEffect(() => {
        if (groupList) {
            filter({
                arr: groupList,
            });
        }
    }, [groupList]);

    return {
        list,
        loading,
        loaded,
        refresh,
        filter,
        page: listPage,
        pageSize: listPageSize,
        total,
        cancel,
    };
}
